// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1yPvj","title":"Header_title__2iJy5","left":"Header_left__XASr7","clinicName":"Header_clinicName__c2Sff"};